export default {
  // Page titles
  'luckySpin.ticket.title': 'Spin Ticket Settings',
  'luckySpin.ticket.management': 'Ticket Management',

  // Form fields
  'luckySpin.ticket.ticketId': 'Ticket ID',
  'luckySpin.ticket.ticketName': 'Ticket Name',
  'luckySpin.ticket.ticketDescription': 'Description',
  'luckySpin.ticket.activityName': 'Bound Activity',
  'luckySpin.ticket.selectActivity': 'Select Activity',
  'luckySpin.ticket.validityType': 'Validity Type',
  'luckySpin.ticket.validitySetting': 'Validity Setting',
  'luckySpin.ticket.validityHours': 'Valid Hours After Receive',
  'luckySpin.ticket.validTimeRange': 'Valid Time Range',
  'luckySpin.ticket.sort': 'Sort Order',
  'luckySpin.ticket.status': 'Status',
  'luckySpin.ticket.remark': 'Remark',
  'luckySpin.ticket.createTime': 'Create Time',
  'luckySpin.ticket.createUser': 'Creator',
  'luckySpin.ticket.updateTime': 'Update Time',
  'luckySpin.ticket.updateUser': 'Updater',

  // Validity types
  'luckySpin.ticket.validity.permanent': 'Permanent',
  'luckySpin.ticket.validity.afterReceive': 'Specified Time After Receive',
  'luckySpin.ticket.validity.fixedTime': 'Fixed Time Period',

  // Status
  'luckySpin.ticket.status.enabled': 'Enabled',
  'luckySpin.ticket.status.disabled': 'Disabled',

  // Buttons
  'luckySpin.ticket.button.add': 'Add Ticket',
  'luckySpin.ticket.button.edit': 'Edit',
  'luckySpin.ticket.button.delete': 'Delete',
  'luckySpin.ticket.button.detail': 'Detail',
  'luckySpin.ticket.button.search': 'Search',
  'luckySpin.ticket.button.reset': 'Reset',

  // Messages
  'luckySpin.ticket.tip.bindRule': 'Each ticket can only be bound to one activity, and an activity can be associated with multiple tickets.',
  'luckySpin.ticket.confirm.delete': 'Are you sure you want to delete this ticket? This action cannot be undone.',
  'luckySpin.ticket.message.createSuccess': 'Created successfully',
  'luckySpin.ticket.message.updateSuccess': 'Updated successfully',
  'luckySpin.ticket.message.deleteSuccess': 'Deleted successfully',
  'luckySpin.ticket.message.operationFailed': 'Operation failed',
  'luckySpin.ticket.message.cannotDeleteWithUnusedTickets': 'Cannot delete: there are unused member tickets',

  // Form validation
  'luckySpin.ticket.validate.ticketNameRequired': 'Please enter ticket name',
  'luckySpin.ticket.validate.ticketNameMax': 'Ticket name cannot exceed 100 characters',
  'luckySpin.ticket.validate.activityRequired': 'Please select an activity',
  'luckySpin.ticket.validate.validityTypeRequired': 'Please select validity type',
  'luckySpin.ticket.validate.validityHoursRequired': 'Please enter valid hours',
  'luckySpin.ticket.validate.validityHoursRange': 'Valid hours range: 1-720',
  'luckySpin.ticket.validate.validTimeRangeRequired': 'Please select valid time range',
  'luckySpin.ticket.validate.statusRequired': 'Please select status',
  'luckySpin.ticket.requiredVipLevel': 'VIP Level Requirement ≥',
  'luckySpin.ticket.validate.requiredVipLevel': 'Please select VIP level requirement (optional)',

  // Usage Restriction
  'luckySpin.ticket.usageRestrictionType': 'Usage Restriction Type',
  'luckySpin.ticket.restrictionAmount': 'Restriction Amount',
  'luckySpin.ticket.usageRestriction.none': 'No Restriction',
  'luckySpin.ticket.usageRestriction.singleDeposit': 'Single Deposit Amount',
  'luckySpin.ticket.usageRestriction.cumulativeDeposit': 'Cumulative Deposit Amount',
  'luckySpin.ticket.usageRestriction.bettingTurnover': 'Betting Turnover',
  'luckySpin.ticket.usageRestriction.bettingTurnoverTip': 'Calculated from ticket receipt time',
  'luckySpin.ticket.validate.restrictionAmountRequired': 'Please enter restriction amount',
  'luckySpin.ticket.validate.restrictionAmountMin': 'Amount must be greater than 0',
  'luckySpin.ticket.placeholder.usageRestrictionType': 'Select usage restriction type',
  'luckySpin.ticket.placeholder.restrictionAmount': 'Enter amount',

  // Placeholders
  'luckySpin.ticket.placeholder.ticketName': 'Enter ticket name',
  'luckySpin.ticket.placeholder.ticketDescription': 'Enter description',
  'luckySpin.ticket.placeholder.selectActivity': 'Select activity',
  'luckySpin.ticket.placeholder.validityType': 'Select validity type',
  'luckySpin.ticket.placeholder.validityHours': 'Enter hours',
  'luckySpin.ticket.placeholder.startTime': 'Start time',
  'luckySpin.ticket.placeholder.endTime': 'End time',
  'luckySpin.ticket.placeholder.sort': 'Enter sort order, default 0',
  'luckySpin.ticket.placeholder.status': 'Select status',
  'luckySpin.ticket.placeholder.remark': 'Enter remark',

  // Modal titles
  'luckySpin.ticket.modal.addTitle': 'Add Ticket',
  'luckySpin.ticket.modal.editTitle': 'Edit Ticket',
  'luckySpin.ticket.modal.detailTitle': 'Ticket Detail',

  // Full Page Form
  'luckySpin.ticket.form.title.add': 'Add Spin Ticket',
  'luckySpin.ticket.form.title.edit': 'Edit Spin Ticket',
  'luckySpin.ticket.form.basicSettings': 'Basic Settings',
  'luckySpin.ticket.form.multiLanguageSettings': 'Multi-language Settings (External Display)',
  'luckySpin.ticket.form.ticketNameInternal': 'Ticket Name (Internal)',
  'luckySpin.ticket.form.ticketNameExternal': 'Ticket Name (External Display)',
  'luckySpin.ticket.form.ticketDescriptionInternal': 'Ticket Description',
  'luckySpin.ticket.form.ticketDescriptionExternal': 'Ticket Description (External Display)',
  'luckySpin.ticket.form.bindActivity': 'Bind Activity',
  'luckySpin.ticket.form.selectActivity': 'Please select lucky spin activity',
  'luckySpin.ticket.form.language': 'Language',
  'luckySpin.ticket.form.selectLanguage': 'Please select language',
  'luckySpin.ticket.form.save': 'Save',
  'luckySpin.ticket.form.back': 'Back',
  'luckySpin.ticket.form.saving': 'Saving...',

  // Lucky Spin Activity Template
  'luckySpin.template.title': 'Wheel Settings',
  'luckySpin.template.prizeConfig': 'Prize Configuration',
  'luckySpin.template.commonParams': 'Common Parameters',

  // Prize Types
  'luckySpin.template.prizeType': 'Prize Type',
  'luckySpin.template.prizeType.cash': 'Cash',
  'luckySpin.template.prizeType.point': 'Points',
  'luckySpin.template.prizeType.physical': 'Physical Prize',
  'luckySpin.template.prizeType.retry': 'Try Again',
  'luckySpin.template.prizeType.noPrize': 'No Prize',

  // Prize Fields
  'luckySpin.template.coinCode': 'Currency',
  'luckySpin.template.cashAmount': 'Amount',
  'luckySpin.template.flowMultiple': 'Wager Multiple',
  'luckySpin.template.pointAmount': 'Points Amount',
  'luckySpin.template.prizeTitle': 'Prize Title (Internal)',
  'luckySpin.template.prizeConfigButton': 'Configure Multi-language',
  'luckySpin.template.prizeConfigured': '✓ Configured',
  'luckySpin.template.prizeLimit': 'Limit',
  'luckySpin.template.probability': 'Probability (%)',
  'luckySpin.template.operation': 'Action',

  // Common Parameters
  'luckySpin.template.visibleEntry': 'Visible Entry',
  'luckySpin.template.ticketOnlyVisible': 'Only visible to users with tickets',
  'luckySpin.template.appOnly': 'APP Only',
  'luckySpin.template.drawLimit': 'Draw Limit',
  'luckySpin.template.requirePhoneVerified': 'Only verified users can draw',
  'luckySpin.template.cooldownSeconds': 'Cooldown (seconds)',

  // Messages
  'luckySpin.template.prizesCountHint': 'Wheel has fixed 8 prizes (8 sectors)',
  'luckySpin.template.totalProbability': 'Total Probability',
  'luckySpin.template.probabilityError': 'Current total is {value}%, needs to be 100%',
  'luckySpin.template.rules': 'Rules',
  'luckySpin.template.rule0': 'Wheel has fixed 8 prizes',
  'luckySpin.template.rule1': 'Probability supports 4 decimals',
  'luckySpin.template.rule2': 'Total probability must = 100%',
  'luckySpin.template.rule3': 'Limit = -1 means unlimited',
  'luckySpin.template.rule4': 'At least one prize required',

  // Validation
  'luckySpin.template.validate.prizeType': 'Please select prize type',
  'luckySpin.template.validate.coinCode': 'Please select currency',
  'luckySpin.template.validate.cashAmount': 'Please enter amount',
  'luckySpin.template.validate.cashAmountNegative': 'Amount cannot be negative',
  'luckySpin.template.validate.flowMultiple': 'Please enter wager multiple',
  'luckySpin.template.validate.flowMultipleMin': 'Wager multiple must ≥ 1',
  'luckySpin.template.validate.pointAmount': 'Please enter points amount',
  'luckySpin.template.validate.pointAmountNegative': 'Points cannot be negative',
  'luckySpin.template.validate.pointAmountInteger': 'Points must be integer',
  'luckySpin.template.validate.prizeTitle': 'Please enter prize title',
  'luckySpin.template.validate.prizeTitleMax': 'Max 100 characters',
  'luckySpin.template.validate.prizeLimit': 'Please enter limit',
  'luckySpin.template.validate.probability': 'Please enter probability',
  'luckySpin.template.validate.probabilityRange': 'Probability range: 0-100',
  'luckySpin.template.validate.cooldownSeconds': 'Please enter cooldown time',
  'luckySpin.template.validate.cooldownSecondsNegative': 'Cooldown cannot be negative',
  'luckySpin.template.validate.probabilitySum': 'Total probability must be 100%',
  'luckySpin.template.validate.prizesCount': 'Wheel must have exactly 8 prizes',

  // Physical Prize Multi-language
  'luckySpin.template.physical.modalTitle': 'Configure Prize Multi-language',
  'luckySpin.template.physical.prizeTitle': 'Prize Title',
  'luckySpin.template.physical.prizeImage': 'Prize Image',
  'luckySpin.template.physical.langConfigured': '{count} languages configured',
  'luckySpin.template.physical.validate.prizeTitle': 'Please enter prize title',
  'luckySpin.template.physical.validate.prizeImage': 'Please upload prize image',
  'luckySpin.template.physical.saveSuccess': 'Multi-language configuration saved',

  // Cash Prize Multi-language
  'luckySpin.template.cash.modalTitle': 'Configure Cash Prize Multi-language',
  'luckySpin.template.cash.prizeImage': 'Prize Image',
  'luckySpin.template.cash.prizeConfigButton': 'Configure Prize Images',
  'luckySpin.template.cash.langConfigured': '{count} languages configured',
  'luckySpin.template.cash.validate.prizeImage': 'Please upload prize image',
  'luckySpin.template.cash.saveSuccess': 'Multi-language configuration saved',

  // Points Prize Multi-language
  'luckySpin.template.points.modalTitle': 'Configure Points Prize Multi-language',
  'luckySpin.template.points.prizeImage': 'Prize Image',
  'luckySpin.template.points.prizeConfigButton': 'Configure Prize Images',
  'luckySpin.template.points.langConfigured': '{count} languages configured',
  'luckySpin.template.points.validate.prizeImage': 'Please upload prize image',
  'luckySpin.template.points.saveSuccess': 'Multi-language configuration saved',

  // Grant Log
  'luckySpin.grantLog.title': 'Ticket Grant Log',
  'luckySpin.grantLog.ticketName': 'Ticket Name',
  'luckySpin.grantLog.grantSource': 'Grant Source',
  'luckySpin.grantLog.grantType': 'Grant Detail',
  'luckySpin.grantLog.userName': 'Member Account',
  'luckySpin.grantLog.activityDataPkCode': 'Select Activity',
  'luckySpin.grantLog.selectActivity': 'Please select activity',
  'luckySpin.grantLog.activityName': 'Wheel Name',
  'luckySpin.grantLog.status': 'Ticket Status',
  'luckySpin.grantLog.grantTime': 'Grant Time',
  'luckySpin.grantLog.type.label': 'Grant Type',
  'luckySpin.grantLog.type.placeholder': 'Select grant type',
  'luckySpin.grantLog.search': 'Search',
  'luckySpin.grantLog.reset': 'Reset',
  'luckySpin.grantLog.export': 'Export',
  'luckySpin.grantLog.exporting': 'Exporting data...',
  'luckySpin.grantLog.exportSuccess': 'Export successful',
  'luckySpin.grantLog.exportFailed': 'Export failed',

  // Grant Source
  'luckySpin.grantLog.source.vipReward': 'VIP Reward',
  'luckySpin.grantLog.source.batchGrant': 'Batch Grant',
  'luckySpin.grantLog.source.systemReward': 'System Reward',
  'luckySpin.grantLog.source.manual': 'Manual',
  'luckySpin.grantLog.source.pointsMall': 'Points Mall',
  'luckySpin.grantLog.source.spinAgain': 'Spin Again',
  'luckySpin.grantLog.source.pointExchange': 'Point Exchange',
  'luckySpin.grantLog.source.actReward': 'Activity Reward',

  // Grant Type
  'luckySpin.grantLog.type.manual': 'Manual',
  'luckySpin.grantLog.type.vipUpgrade': 'VIP Upgrade',
  'luckySpin.grantLog.type.activityReward': 'Activity Reward',
  'luckySpin.grantLog.type.system': 'System',

  // Ticket Status
  'luckySpin.grantLog.status.unused': 'Unused',
  'luckySpin.grantLog.status.used': 'Used',
  'luckySpin.grantLog.status.expired': 'Expired',
  'luckySpin.grantLog.status.cancelled': 'Cancelled',

  // Spin Log
  'luckySpin.spinLog.title': 'Spin Use Log',
  'luckySpin.spinLog.userName': 'Member Account',
  'luckySpin.spinLog.activityName': 'Wheel Name',
  'luckySpin.spinLog.ticketName': 'Ticket Name',
  'luckySpin.spinLog.spinTime': 'Spin Time',
  'luckySpin.spinLog.prizeType': 'Prize Type',
  'luckySpin.spinLog.prizeContent': 'Prize Content',
  'luckySpin.spinLog.grantStatus': 'Grant Status',
  'luckySpin.spinLog.grantTime': 'Grant Time',
  'luckySpin.spinLog.search': 'Search',
  'luckySpin.spinLog.reset': 'Reset',
  'luckySpin.spinLog.export': 'Export',
  'luckySpin.spinLog.exporting': 'Exporting data...',
  'luckySpin.spinLog.exportSuccess': 'Export successful',
  'luckySpin.spinLog.exportFailed': 'Export failed',

  // Prize Types
  'luckySpin.spinLog.prize.cash': 'Cash',
  'luckySpin.spinLog.prize.points': 'Points',
  'luckySpin.spinLog.prize.physical': 'Physical',
  'luckySpin.spinLog.prize.again': 'Spin Again',
  'luckySpin.spinLog.prize.none': 'No Prize',

  // Grant Status
  'luckySpin.spinLog.grant.pending': 'Pending',
  'luckySpin.spinLog.grant.success': 'Success',
  'luckySpin.spinLog.grant.failed': 'Failed',
};

